export default {
  data() {
    return {
      isStartingInternalDownload: false,
    };
  },
  methods: {
    isInternalDownload(ug) {
      return ug.download_ticket === 'INSTALLABLE_IPA_DOWNLOAD_ONLY';
    },
    getExternalDownloadLink(ug) {
      if (!ug.download_ticket) {
        return '';
      }

      return `/redirect/${ug.download_ticket}`;
    },
    getDownloadFailureReason(ug) {
      return ug.no_download_ticket_failure_reason?.translated;
    },
    async startInternalDownload(ug) {
      if (this.isStartingInternalDownload) {
        return;
      }

      this.isStartingInternalDownload = true;
      try {
        const response = await this.installApp(ug.object.id, 'universal', {
          installationTicket: ug.installation_ticket,
          showSuccessConfirm: false,
          asIpaFile: true,
          featuresConfirmText: this.$t('DOWNLOAD'),
        });

        console.log('[DEBUG] Download response:', response);

        // Check if the installation was cancelled
        if (response && response.cancelled) {
          console.log('[DEBUG] Download was cancelled by user');
          return; // Exit early, don't try to navigate
        }

        // Make sure we have a response with data before trying to access properties
        if (response && response.data && response.data.command_uuid) {
          this.$router.push({
            name: 'app-download',
            params: {
              id: ug.object.identifier,
            },
            query: {
              commandUuid: response.data.command_uuid,
            },
          });
        } else {
          console.error('[DEBUG] Invalid response format for download:', response);
        }
      } catch (error) {
        console.error('[DEBUG] Download error:', error);
      } finally {
        this.isStartingInternalDownload = false;
      }
    },
  },
};
